import type { RootState } from "@/src/common/redux/store";

export const getColorScheme = (state: RootState) => state.general.colorScheme;
